<template>
  <div class="container-fluid">
    <el-container>
      <el-header height="15%">
        <div class="row m-4">
          <div class="col-md-3">
            <h4>Текстовые страницы</h4>
          </div>
          <div class="col-md-2">
            <el-button type="success" @click="(e) => addTextPage(e)">
              Добавить страницу
            </el-button>
          </div>
        </div>
      </el-header>
      <el-main height="80%">
        <el-form aria-label="Поиск">
          <el-row>
            <el-col :span="8">
              <el-form-item label="Поиск по названию">
                <el-col :span="14">
                  <el-input
                    v-model="query.q"
                    @change="setQueryReset"                    
                  ></el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table :data="pages" empty-text="Нет данных" style="width: 100%">
          <el-table-column prop="id" label="Id" width="50"></el-table-column>
          <el-table-column prop="title" label="Название"></el-table-column>
          <el-table-column label="Активность">
            <template slot-scope="scope">
              <span v-if="!pages[scope.$index].activity">Нет</span>
              <span v-else>Да</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="Действия" width="400">
            <template slot-scope="scope">
              <div class="faq-section__nav">
                <el-button
                  v-if="pages[scope.$index].activity"
                  size="mini"
                  type="primary"
                  plain
                  @click="(e) => hidePage(pages[scope.$index].id, e)"
                >
                  Скрыть
                </el-button>
                <el-button
                  v-if="!pages[scope.$index].activity"
                  size="mini"
                  type="primary"
                  ref=""
                  plain
                  @click="(e) => restorePage(pages[scope.$index].id, e)"
                >
                  Показать
                </el-button>
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  class="text-page__edit-btn"
                  @click="(e) => editTextPage(pages[scope.$index].id, e)"
                >
                  Редактировать
                </el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click.native.prevent="deletePage(pages[scope.$index].id)">
                  Удалить
                </el-button>
                <!-- <el-popconfirm
                  :title="'Удалить этот раздел?'"
                  :hide-icon="true"
                  :confirmButtonText="'Да'"
                  :cancelButtonText="'Нет'"
                  @confirm="(e) => deletePage(pages[scope.$index].id)"
                >
                  <template #reference>
                    <el-button
                      size="mini"
                      type="danger"
                      plain
                      class="el-table__row--remove-btn"
                    >
                      Удалить
                    </el-button>
                  </template>
                </el-popconfirm> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="5%">
        <el-pagination
          v-show="paginator"
          background
          layout="prev, pager, next"
          :total="paginator.total"
          :current-page.sync="current"
          @current-change="getPage(current)"
          :hide-on-single-page="false"
          :page-size="paginator.per_page"
          :page-count="paginator.last_page"
        >
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import qs from "qs";
import axios from 'axios';
import { SETPRELOADER_STATE } from '../../store/mutation-types.js';

export default {
  data() {
    return {
      query: {
        q: null,
        page: 1,
      },
      pages: [],
      paginator: {},
      searchTimeout: null,
      sortItems: [
        {
          value: 'title.asc',
          name: 'Название(А-Я)'
        },
        {
          value: 'title.desc',
          name: 'Название(Я-А)'
        },
        {
          value: 'sort.asc',
          name: 'Сортировка(А-Я)'
        },
        {
          value: 'sort.desc',
          name: 'Сортировка(Я-А)'
        },
        {
          value: 'activtity.asc',
          name: 'Активность(А-Я)'
        },
        {
          value: 'activtity.desc',
          name: 'Активность(Я-А)'
        }
      ],
      current: null
    }
  },
  mounted() {
    this.initParams(this.$route.query);
    this.getPages(this.getQuery(this.$route.query));    
  },
  watch:{
  '$route.query'(v){   
      const query = this.getQuery(v)   
          if (query){              
              this.getPages(query)
          }
      }
  },
  methods: {
    addTextPage(e) {
      const t = e.target;

      const queryParams = qs.stringify(this.query, { skipNulls: true })

      this.$store.commit(SETPRELOADER_STATE, true)
      t.style.pointerEvents = 'none';

      axios.get(`/page/footer-section?${queryParams}`).then((response) => {
        this.$store.dispatch('setFooterSections', response.data)
        this.$router.push('/text-pages/create')
      }).finally(() => {
        t.style.pointerEvents = 'all';
        this.$store.commit(SETPRELOADER_STATE, false)
      })
    },
    getPages(query) {      
      this.$store.commit(SETPRELOADER_STATE, true)

      axios.get(`/page${query}`).then((response) => {
        this.pages = response.data.data;
        this.paginator = response.data.meta;
        this.current = response.data.meta.current_page;
      }).finally(() => {
        this.$store.commit(SETPRELOADER_STATE, false)
      })
    },
    getPage(pageNum) {
        if(pageNum!==null){
          this.query.page = pageNum
          this.setQuery(); 
        }
    },
    editTextPage(id) {
      this.$router.push(`/text-pages/${id}/update`)
    },    
    deletePage(id) {
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true)
      }, 400)

      axios.delete(`/page/${id}`).then(() => {
        this.pages = [...this.pages.filter((el) => el.id !== id)];
      }).finally(() => {
        clearTimeout(loader)
        this.$store.commit(SETPRELOADER_STATE, false)
      })
    },
    restorePage(id, e) {
      const btn = this.getTarget(e);
      btn.style.pointerEvents = 'none';
      
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true)
      }, 400)

      axios.post(`/page/${id}/restore`, ).then(() => {
        
      this.pages = [...this.pages.map((el) => {
        if (el.id === id) {
          el.activity = true
        }

        return el
      })]
      }).finally(() => {
        clearTimeout(loader);
        this.$store.commit(SETPRELOADER_STATE, false)
        btn.style.pointerEvents = 'all';
      })
    },
    getTarget(e) {
      const t = e.target;

      return t.classList.contains('el-button') ? t : t.parentNode;
    },
    hidePage(id, e) {
      const btn = this.getTarget(e);
      btn.style.pointerEvents = 'none';
      
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true)
      }, 400)

      axios.post(`/page/${id}/hide`, ).then(() => {
        
      this.pages = [...this.pages.map((el) => {
        if (el.id === id) {
          el.activity = false
        }
        return el
      })]

      }).finally(() => {
        clearTimeout(loader);
        this.$store.commit(SETPRELOADER_STATE, false)
        btn.style.pointerEvents = 'all';
      })
    },    
    setQueryReset(){
      this.query.page = 1
      this.setQuery()
    },
    setQuery(){
      const result = {};
      let isChange = false;
      
      if (this.query.q) {
        isChange = true;
        result['q']=this.query.q
      }
      if(this.query.page){
        isChange = true
        result['page']=this.query.page
      }

      if (isChange) {
        const q = this.getQuery(result)
        this.$router.push({
          path: 'text-pages' + q,
        })
      }
    }, 
    getQuery(query) {
      if (Object.keys(query).length > 0){        
        const qs = require('qs');
        return `?${qs.stringify(query)}`
      }
      return ''
    },
    initParams(query){
      if (!query){
        return
      }
      if (query.q){
        this.query.q = query.q
      }
      if(query.page){
        this.query.page= query.page
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .text-page {
    &__edit-btn {
      margin-right: 10px;
    }
  }
</style>